import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { Tabs, Menu, Dropdown, Button, Modal } from 'antd';
import { EditOutlined, PlusOutlined, CloseOutlined, EllipsisOutlined } from '@ant-design/icons';

import SpinFull from '../../../components/SpinFull';
import SuperTable from '../../../components/SuperTable';
import StationSettingDeviceEditModal from './StationSettingDeviceEditModal';

export default function StationSettingDeviceTab(props) {
  const history = useHistory();
  const {
    station,
    stationDevices,
    onUpdate,
  } = props;

  const [tableKey, setTableKey] = useState(Math.random().toString());
  const [editModal, setEditModal] = useState({
    key: Math.random().toString(),
    visible: false,
    stationDeviceId: null,
  });

  const columns = [
    {
      template: 'action',
      key: 'action',
      width: 80,
      render: (value, record) => {
        return (
          <Dropdown
            overlay={
              <Menu onClick={value => {
                switch (value.key) {
                  case 'edit': {
                    setEditModal({
                      ...editModal,
                      key: Math.random().toString(),
                      visible: true,
                      stationDeviceId: record.id,
                    });
                    break;
                  }
                  case 'remove': {
                    Modal.confirm({
                      title: 'Confirm to REMOVE device',
                      content: 'Are you sure to remove this device?',
                      onOk: () => {
                        onUpdate({
                          name: 'DEVICE',
                          action: 'REMOVE',
                          id: record.id,
                        });
                        setTableKey(Math.random().toString());
                      },
                    });
                  }
                  break;
                }
              }}>
                <Menu.Item key="edit">
                  <EditOutlined />
                  Edit
                </Menu.Item>
                <Menu.Item key="remove">
                  <CloseOutlined />
                  Remove
                </Menu.Item>
              </Menu>
            }
          >
            <Button
              type="default"
              shape="round"
            >
              <EllipsisOutlined />
            </Button>
          </Dropdown>
        );
      },
    },
    {
      template: 'id',
      key: 'id',
      width: 40,
      title: 'ID',
    },
    {
      key: 'name',
      title: 'Name',
    },
    {
      key: 'model',
      title: 'Model',
    },
    {
      template: 'isEnabled',
      key: 'isEnabled',
      title: 'Enabled',
    },
  ];

  const loadDataSource = async (body) => {
    return {
      data: stationDevices.slice(body.from, body.from + body.count),
      totalCount: stationDevices.length,
    };
  };

  return (
    station && stationDevices ? (
      <>
        <div className="top-nav">
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => {
              setEditModal({
                ...editModal,
                key: Math.random().toString(),
                visible: true,
                stationDeviceId: null,
              });
            }}
          >
            Add Device
          </Button>
        </div>

        <SuperTable
          key={tableKey}
          loadDataSource={loadDataSource}
          columns={columns}
          pagination={false}
        />

        <StationSettingDeviceEditModal
          key={editModal.key}
          stationId={station.id}
          stationDeviceId={editModal.stationDeviceId}
          stationDevice={editModal.stationDeviceId ? stationDevices.find(stationDeviceItem => stationDeviceItem.id === editModal.stationDeviceId) : null}
          visible={!!editModal.visible}
          onUpdate={onUpdate}
          onOk={() => {
            setEditModal({
              ...editModal,
              visible: false,
            });
            setTableKey(Math.random().toString());
          }}
          onCancel={() => {
            setEditModal({
              ...editModal,
              visible: false,
            });
          }}
        />
      </>
    ) : <SpinFull />
  );
};